import client from '/src/services/client.js';
import { env } from '/src/var/env';
import Storage from '/src/utils/storage';

const storageLocal = Storage('local');

export default {
    getConversations: (data) => client.get('api/conversations', data),
    getConversation: ({ id }) => client.get(`api/conversation/${id}`, {}),
    getConversationAudio: ({ call_id }) => client.get(`api/conversation/${call_id}/audio`, {}, 'arraybuffer', {}),

    translateConversation: ({call_id}) => client.post(`calls/conversation/${call_id}/translate`),
    translateConversationStatus: ({call_id}) => client.get(`calls/conversation/${call_id}/translation-status`),

    getCriterias: (data) => client.get('api/criterias', data),
    getCriteriasAll: (data) => client.get('api/criterias/all', data),
    getDashboardAnalytics: (filters) => client.get('analytics/dashboard', filters || {}),
    updateCriteriaConversation: (callId, criteriaId, data) => client.put(`calls/conversation/${callId}/criteria/${criteriaId}`, data),
    addCriteriaDetection: (callId, criteriaId, data) => client.post(`calls/conversation/${callId}/criteria/${criteriaId}/detection`, data),
    updateDetectionFeedback: (id, segmentIndex, data) => client.put(`calls/criteria_conversation/${id}/detection/${segmentIndex}/feedback`, data),
    updateConversation : (call_id, data) => client.put(`calls/conversation/${call_id}`, data),
    deleteConversation: (call_id) => client.delete(`calls/conversation/${call_id}`),

    processRefresh: (data) => client.post(`calls/conversation/${data.call_id}/refresh`, data),
    resetConversationReview: (call_id) => client.post(`calls/conversation/${call_id}/reset`, {}),

    // Admin only: re-analyze every conversation of a date range (same work as the Refresh button)
    previewBulkRefresh: (data) => client.post('calls/conversations/bulk-refresh/preview', data),
    getBulkRefreshJobs: () => client.get('calls/conversations/bulk-refresh', {}),
    startBulkRefresh: (data) => client.post('calls/conversations/bulk-refresh', data),
    cancelBulkRefresh: () => client.post('calls/conversations/bulk-refresh/cancel', {}),
    getBulkRefreshProgress: (jobId) => client.get(`calls/conversations/bulk-refresh/${jobId}`, {}),
    getBulkRefreshFailures: (jobId) => client.get(`calls/conversations/bulk-refresh/${jobId}/failures`, {}),
    uploadAudioFile: (formData) => client.post('calls/upload/test-file', formData),

    sendPresenceHeartbeat: (call_id) => client.post(`calls/conversation/${call_id}/presence/heartbeat`, {}),
    leavePresence: (call_id) => client.delete(`calls/conversation/${call_id}/presence`),
    // Closing/reloading the tab does not run React cleanups: keepalive lets this last
    // request (which also ends the review-time visit) survive the page unload.
    leavePresenceOnUnload: (call_id) => {
        const token = storageLocal.get('token');
        fetch(`${env.PYTHON_APP_API_PATH}/calls/conversation/${call_id}/presence`, {
            method: 'DELETE',
            keepalive: true,
            headers: token ? { Authorization: 'Bearer ' + token } : {},
        }).catch(() => {});
    },
    getConversationsPresence: (call_ids) => client.post(`calls/conversations/presence`, { call_ids }),
}
